<ng-container *ngIf="state$ | async as state">
  <button class="heading" (click)="false && toggleGroup($event)">
    {{ facet.name }}
  </button>

  <ng-template
    *ngIf="!facet.selectionType || facet.selectionType === SelectionType.MULTISELECT"
    [ngTemplateOutlet]="normal"
    [ngTemplateOutletContext]="{ state: state }"
  ></ng-template>
  <ng-template
    *ngIf="facet.selectionType === SelectionType.SINGLE"
    [ngTemplateOutlet]="single"
  ></ng-template>
  <ng-template
    *ngIf="facet.selectionType === SelectionType.RANGE"
    [ngTemplateOutlet]="range"
  ></ng-template>
</ng-container>

<ng-template #normal let-state="state">
  <a
    *ngFor="let value of facet.values | slice: 0 : state.topVisible"
    #facetValue
    routerLink="./"
    [queryParams]="getLinkParams(value)"
    class="value"
    [class.selected]="value.selected"
    [cxFocus]="value.name"
    (keydown.space)="openLink($event)"
  >
    <span>
      <span class="label">{{ value.name }}</span>
    </span>
  </a>

  <div class="more">
    <a
      *ngFor="let value of facet.values | slice: state.topVisible : state.maxVisible"
      #facetValue
      routerLink="./"
      [queryParams]="getLinkParams(value)"
      class="value"
      [class.selected]="value.selected"
      [cxFocus]="value.name"
      (keydown.space)="openLink($event)"
    >
      <span>{{ value?.name || value?.code }} </span>
    </a>

    <button
      *ngIf="state.maxVisible > state.topVisible"
      (click)="decreaseVisibleValues()"
      class="cx-action-link"
      cxFocus="moreorless"
    >
      {{ 'productList.showLess' | cxTranslate }}
    </button>

    <button
      *ngIf="state.maxVisible > 0 && state.maxVisible < facet.values.length"
      (click)="increaseVisibleValues()"
      class="cx-action-link"
      cxFocus="moreorless"
    >
      {{ 'productList.showMore' | cxTranslate }}
    </button>
  </div>
</ng-template>

<ng-template #range>
  <label
    class="eb-facet__range-label"
    [ngClass]="{
      'eb-facet__range-label--active': rangeActive,
      'eb-facet__range-label--inactive': !rangeActive,
      'eb-facet__range-label--single': this.facet?.values?.length === 1
    }"
    (click)="toggleRange()"
  >
    <ng-container *ngIf="this.facet?.values?.length > 1">
      {{ 'productList.rangeFacet.' + (rangeActive ? '' : 'in') + 'active' | cxTranslate }}
    </ng-container>
    <ng-container *ngIf="this.facet?.values?.length === 1">
      {{ this.facet?.values[0]?.name || this.facet?.values[0]?.code }}
    </ng-container>
  </label>
  <ngx-slider
    *ngIf="this.facet?.values?.length > 1"
    class="eb-facet__range-slider"
    [ngClass]="{
      'eb-facet__range-slider--active': rangeActive,
      'eb-facet__range-slider--inactive': !rangeActive
    }"
    [options]="ngxOptions"
    [value]="lowValue"
    [highValue]="highValue"
    (userChangeEnd)="rangeActive = true; rangeChange($event)"
  ></ngx-slider>
</ng-template>

<ng-template #single>
  <select (change)="singleChange($event)">
    <option [value]="queryWithoutFacet" selected>
      {{ 'selectBox.placeholder' | cxTranslate }}
    </option>
    <option *ngFor="let value of facet.values" [value]="value.code" [selected]="value.selected">
      {{ value?.name || value?.code }}
    </option>
  </select>
</ng-template>
